/* GOC bag build: "Buy now" button + small bag helpers.
 * Loaded once per page from snippets/cart-drawer.liquid. Uses document-level delegation so it keeps
 * working after the product form or the bag drawer is re-rendered. */
(function () {
  if (window.__gocBag) return;
  window.__gocBag = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---- Buy now: send the selected variant + quantity straight to checkout ---- */
  function showError(pf, message) {
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    if (!wrap) return;
    var msg = wrap.querySelector('.product-form__error-message');
    if (msg) msg.textContent = message;
    wrap.removeAttribute('hidden');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-goc-buy-now]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var pf = btn.closest('product-form');
    var form = pf && pf.querySelector('form');
    if (!form) return;
    var data = new FormData(form);
    if (!data.get('id')) return;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          showError(pf, res.description || res.message || 'Sorry, that could not be added.');
          return;
        }
        window.location.href = root + 'checkout';
      })
      .catch(function () { showError(pf, 'Sorry, something went wrong. Please try again.'); })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('loading');
      });
  });

  /* Keep Buy now disabled exactly when Add to bag is disabled (sold out / coming soon / unavailable variant). */
  function bind(btn) {
    if (btn.__gocBound) return;
    var submit = btn.closest('product-form') && btn.closest('product-form').querySelector('.product-form__submit');
    if (!submit) return;
    btn.__gocBound = true;
    var sync = function () { btn.disabled = submit.hasAttribute('disabled'); };
    sync();
    new MutationObserver(sync).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
  }
  function scan() { document.querySelectorAll('[data-goc-buy-now]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });

  /* On the full bag page the header bag icon should not pop the drawer over the page. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (a && /^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?cart\/?$/.test(window.location.pathname)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
})();